import { useEffect, useState } from "react";

const MIAMI_TZ = "America/New_York";

// Sidebar bottom block: Miami Headquarters clock only.
// User identity lives exclusively in the upper-right header control.
export function SidebarClock() {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const t = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(t);
  }, []);

  const time = now.toLocaleTimeString("en-US", {
    timeZone: MIAMI_TZ, hour: "numeric", minute: "2-digit", second: "2-digit", hour12: true,
  });

  return (
    <div data-testid="sidebar-footer">
      {/* Batch I: Total Technologies brand mark — secondary to the REACH logo,
          centered above the divider + Miami Headquarters clock. */}
      <div className="flex justify-center px-5 pb-3 pt-2">
        <img src="/total_technologies_logo.webp" alt="Total Technologies — A Total Facility Solutions, Inc division"
          className="h-auto w-36 max-w-full opacity-90" data-testid="sidebar-tt-logo" />
      </div>
      <div className="border-t border-white/10 px-5 py-4" data-testid="sidebar-clock">
        <p className="text-[10px] font-bold uppercase tracking-[0.18em] text-white/45">Miami Headquarters</p>
        <div className="mt-1.5 flex items-baseline justify-between gap-2">
          <span className="text-[10px] font-bold uppercase tracking-[0.15em] text-[#65AB15]">Eastern</span>
          <span className="font-mono text-sm font-semibold tabular-nums text-white/90" data-testid="clock-miami">
            {time}
          </span>
        </div>
      </div>
    </div>
  );
}
